import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useMapContext } from '../../../context';
import { useApplicationContext } from '../../../../ApplicationContext';
import { pushErrorNotification } from '../../../../../actions/notifications';
import { EErrorNotificationType } from '../../../../../types/notifications';
import { GeoLocationButton } from './GeoLocationButton';

export const GeoLocationButtonContainer: React.FC = props => {
  const dispatch = useDispatch();
  const { map, ymaps } = useMapContext();
  const { logger } = useApplicationContext();

  const handleGeoLocationError = React.useCallback(
    error => {
      logger.error(error, { domain: 'Controls/GeoLocationButton/handleGeoLocationClick()' });

      dispatch(pushErrorNotification(EErrorNotificationType.GeoLocation));
    },
    [logger, dispatch],
  );

  return <GeoLocationButton {...props} map={map} ymaps={ymaps} onGeoLocationError={handleGeoLocationError} />;
};
